var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttemptStats({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4167 22C17.9396 22 22.4167 17.5228 22.4167 12C22.4167 6.47715 17.9396 2 12.4167 2C6.8939 2 2.41675 6.47715 2.41675 12C2.41675 17.5228 6.8939 22 12.4167 22Z",
    stroke: "#121216",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4167 18C15.7305 18 18.4167 15.3137 18.4167 12C18.4167 8.68629 15.7305 6 12.4167 6C9.10304 6 6.41675 8.68629 6.41675 12C6.41675 15.3137 9.10304 18 12.4167 18Z",
    stroke: "#121216",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4167 14C13.5213 14 14.4167 13.1046 14.4167 12C14.4167 10.8954 13.5213 10 12.4167 10C11.3122 10 10.4167 10.8954 10.4167 12C10.4167 13.1046 11.3122 14 12.4167 14Z",
    stroke: "#121216",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttemptStats);
export default __webpack_public_path__ + "static/media/attempt-stats.0f1933cef04bf61c1d3a0125e23d1a49.svg";
export { ForwardRef as ReactComponent };